import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { WindowRef } from '../../core/window';

@Injectable({
  providedIn: 'root',
})
export class WindowUtils {
  constructor(
    private windowRef: WindowRef,
    @Inject(DOCUMENT) protected document: any
  ) {}

  public scrollIntoView(htmlElement: HTMLElement, scrollableElement?: HTMLElement): void {
    //Scroll into view but remove the page header offset
    if (this.windowRef.isBrowser()) {
      const elementToScroll = scrollableElement || this.windowRef.nativeWindow;
      const scrollYDistance = scrollableElement ? scrollableElement.scrollTop : this.windowRef.nativeWindow.scrollY;
      const headerHeight = this.document.getElementById('header')?.offsetHeight || 90; // Header height may have two values: 90px - desktop, 130px - mobile

      elementToScroll.scrollTo({
        top: htmlElement.getBoundingClientRect().top + scrollYDistance - headerHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  getElement(selector: string): HTMLElement {
    if (this.windowRef.isBrowser()) {
      return this.document.querySelector(selector) as HTMLElement;
    }
  }

  addStyleClassToElement(selector: string, styleClass: string): void {
    if (this.windowRef.isBrowser()) {
      const el = this.document.querySelector(selector) as HTMLElement;
      if (!el?.classList?.contains(styleClass)) {
        el?.classList?.add(styleClass);
      }
    }
  }

  removeStyleClassFromElement(selector: string, styleClass: string): void {
    if (this.windowRef.isBrowser()) {
      const el = this.document.querySelector(selector) as HTMLElement;
      if (el?.classList?.contains(styleClass)) {
        el.classList.remove(styleClass);
      }
    }
  }
}
